import { render } from "./client_service.html?vue&type=template&id=3132d2d2&external"
import script from "./client_service.js?vue&type=script&lang=js&external"
export * from "./client_service.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__